import { Kind as IconKind } from '@zoom/components/dist/Icon';
import { LinkProps } from '@zoom/components/dist/Link';

import { PATH_LOGOUT, PATH_MANAGE_ACCOUNT, PATH_QUALITY_MANAGEMENT, PATH_USER_MANAGEMENT } from '../../router/routes';
import { Values } from '../../types';

export const Applications = {
  QM: 'QM',
  WFM: 'WFM',
  UM: 'User Management',
} as const;

export interface UserLinkType {
  href: string;
  icon: IconKind;
  nameKey: string;
  slug: string;
  target?: LinkProps['target'];
}

export interface AppLinkType extends UserLinkType {
  kcAppName: Values<typeof Applications>;
}

export const userLinks: UserLinkType[] = [
  // manage user account
  {
    href: PATH_MANAGE_ACCOUNT,
    icon: 'manage_account',
    nameKey: 'manageUserAccount',
    slug: 'manage-account',
    target: '_blank',
  },
  // logout
  {
    href: PATH_LOGOUT,
    icon: 'logout',
    nameKey: 'logout',
    slug: 'logout',
  },
];

export const appSwitcherLinks: AppLinkType[] = [
  {
    href: PATH_QUALITY_MANAGEMENT,
    icon: 'quality_management',
    nameKey: 'qualityManagement',
    slug: 'quality-management',
    kcAppName: Applications.QM,
  },
  {
    href: PATH_USER_MANAGEMENT,
    icon: 'user-management',
    nameKey: 'userManagement',
    slug: 'user-management',
    kcAppName: Applications.UM,
    target: '_blank',
  },
];
